"use client";

import { createStyle } from "~/common/utils/create-style";
import { SVGError } from "~/common/components/svg/error";

interface ErrorPageProps {
  type: "global" | "404" | "403";
}

const errorConfig: Record<
  "404" | "403" | "global",
  { title: string; message: string }
> = {
  "404": {
    title:
      "The page you are looking for does not exist or the URL was entered incorrectly",
    message: "Please check the address and try again.",
  },
  "403": {
    title: "Forbidden Page",
    message: "You do not have permission to access this page.",
  },
  global: {
    title: "Sorry, we’re having trouble loading this application",
    message: "Please try again later.",
  },
};

function ErrorPage({ type }: ErrorPageProps) {
  const { title, message } = errorConfig[type];

  return (
    <div className={style.container()}>
      <div className={style.iconWrapper()}>
        <SVGError />
      </div>
      <h1 className={style.title()}>{title}</h1>
      <p className={style.message()}>{message}</p>
    </div>
  );
}

const style = createStyle({
  slots: {
    container: [
      "self-center flex flex-col items-center justify-center gap-16 text-text-primary",
      "text-center",
      "w-[400px] h-screen mx-auto",
    ],
    title: "text-title-4",
    message: "text-body-1",
    iconWrapper: "text-text-action",
  },
})();

export { ErrorPage };
